import { Component } from '@angular/core'
import {
	NavController,
	LoadingController,
	IonicPage,
	NavParams,
	ToastController
} from 'ionic-angular'


import { DeviceProvider } from '../../providers/device/device'

import { Device } from '../../models/models'
import { AuthProvider } from '../../providers/auth/auth'
import { ControlPanelPage } from '../control-panel/control-panel'
@IonicPage()
@Component({
	selector: 'page-device-edit',
	templateUrl: 'device-edit.html',
})
export class DeviceEditPage {
	isDeviceLoading: boolean = true;
	device: Device = null;
	loading: any//loading controller

	constructor(
		public auth: AuthProvider,
		public devices: DeviceProvider,
		public loadingCtrl: LoadingController,
		public navCtrl: NavController,
		public navParams: NavParams,
		public toastCtrl: ToastController
	) {
		this.device = navParams.get('device')
	}

	ionViewWillEnter() {
		this.refresh()
	}

	public goToControlPanel() {
		this.navCtrl.setRoot(ControlPanelPage)
	}
	refresh() {
		let self = this
		this.isDeviceLoading = true
		this.devices.getById(this.device.id).then((device: Device) => {
			self.device = device
			self.isDeviceLoading = false
			console.debug('Dispositivo riletto: ', self.device)
		}).catch(error => {
			self.isDeviceLoading = false
			console.error("Errore recuperando i dati del dispositivo:", error)
			let toast = self.toastCtrl.create({
				message: 'Errore recuperando i dati del dispositivo',
				position: 'middle',
				duration: 3000,
				cssClass: "danger"
			})
			toast.present()
		})
	}

	save() {
		let self = this
		this.loading = this.loadingCtrl.create({
			content: 'Salvataggio in corso...',
			dismissOnPageChange: false
		})
		this.loading.present()
		this.devices.update(this.device).then(
			(device: Device) => {
				this.loading.dismiss()
				let toast = self.toastCtrl.create({
					message: 'Dispositivo ' + this.device.identifier + ' "' + this.device.name + '" salvato',
					position: 'middle',
					duration: 3000
				})
				toast.present()
				this.navCtrl.pop()
			}).catch(error => {
				this.loading.dismiss()
				console.error("Errore creando il dispositivo:", error)
			})
	}

	undo() {
		this.navCtrl.pop()
	}
}



// WEBPACK FOOTER //
// ./src/pages/device-edit/device-edit.ts